var font = {"1":"M6.5,1384l265.9,265.8h268.5v-1700h191.7v-345.2H6.5v345.2h189.2v1145.2H6.5V1384z",
"2":"M351.6,479.1V-50.1h513.9v204.5H1213v-549.7H6.5V571l265.1,263.4h593.9v470.4H351.6v-209.6H9V1384l263.3,265.8h677.5L1213,1384V744.9L949.8,479.1H351.6z",
"3":"M867.9-50.1v529.2H476.8v355.3h391.1v470.4H351.6v-209.6H6.5V1384l265.8,265.8h674.9l265.9-265.8V765.3l-25.6-30.7l-81.9-92l94.6-99.7c1.6,0,2.5-0.9,2.5-2.5l10.3-10.3v-659.4L949.7-395.3H272.3L6.5-129.4v283.7h345.1V-50.1H867.9z",
"4":"M589.3-395.3v345.2h184.1v253.1H98.5l-92,403.9l720.9,1043h391.2V530.1h186.6V202.9h-186.6V-50.1h186.6v-345.2H589.3zM372,530.1h401.3v562.4L372,530.1z",
"5":"M272.3,479.1L6.5,742.9v906.9H1213v-345.1H351.5V834.4h595.7L1213,571v-700.4L947.2-395.3H272.3L6.5-129.4v283.7h345.1V-50.1h513.9v529.2H272.3z",
"6":"M865.3,1304.7H351.5V834.4h598.2L1213,571v-700.4L949.7-395.3H272.3L6.5-129.4v1515.9l265.8,263.3h677.4L1213,1384v-288.9H865.3V1304.7zM351.5-50.1h513.8v531.7H351.5V-50.1z",
"7":"M1213,1299.6L545.9-50.1h168.7v-345.2H6.5v345.2h168.7l669.6,1354.9H351.5v-209.6H6.5v554.7H1213V1299.6z",
"8":"M1095.4,642.6c51.1-51.2,90.3-88.6,117.6-112.6v-659.4L949.7-395.3H272.3L6.5-129.4v659.4c61.3,66.6,96.2,104,104.7,112.6L6.5,765.3V1384l265.8,265.8h677.4L1213,1384V765.3L1095.4,642.6zM351.5,834.4h513.9v470.4H351.5V834.4zM351.5-50.1h513.9v531.7H351.5V-50.1z",
"9":"M351.5-50.1h513.8v531.7H271.5L6.5,744.9V1384l265.8,265.8h677.4l263.4-263.3V-129.4L949.7-395.3H272.3L6.5-129.4v283.7h345.1V-50.1zM865.3,834.4v470.4H351.5V834.4H865.3z",
"0":"M1213-129.4L947.1-395.3H272.3L6.5-129.4V1384l265.8,265.8h677.4L1213,1384V-129.4zM865.3-50.1v1354.9H351.5V-50.1H865.3z",
"A":"M374.2-59.4L322-395.3H6.5l338.2,1797.6h372.2l338.3-1797.6H739.6L687.3-59.4L374.2-59.4zM530.7,952.9l-118-762.6l236.1,0L530.7,952.9z",
"B":"M6.5,1402.3h746.8l188.4-163.4V680.5L762.3,551.1L941.6,424v-656L753.2-395.3l-746.8,0V1402.3zM664.7,1154.9H283.4v-488l381.3,0V1154.9zM664.7-145.7v565.2l-381.3,0v-565.2L664.7-145.7z",
"C":"M941.6,1238.9V882.5H664.7v272.4H283.3V-145.7l381.3,0v465.3h276.9v-551.5L750.9-395.3l-553.9,0L6.5-231.9v1470.8l190.6,163.4h553.9L941.6,1238.9z",
"D":"M6.5,1402.3h783l188.4-163.4V-231.9L789.5-395.3l-783,0V1402.3zM703.3-145.7v1300.6H283.3V-145.7L703.3-145.7z",
"E":"M6.5,1402.3h692.3v-247.4H283.4V753.2H558V503.5H283.4v-649.2l419.9,0v-249.7l-696.8,0V1402.3z",
"F":"M283.3-395.3H6.5v1797.6h692.3v-247.4H283.3v-404h247.4V503.5H283.3V-395.3z",
"G":"M939.3,1238.9V855.3H664.7v299.6H283.3V-145.7l381.4,0v485.7H558v215.6l494.8,0V340.1l-113.5,0v-572L751-395.3l-553.9,0L6.5-231.9v1470.8l188.4,163.4H751L939.3,1238.9z",
"H":"M6.5,1402.3h276.9V823.5l342.8,0v578.8h274.6V-395.3H626.1v969.2H283.3v-969.2H6.5V1402.3z",
"I":"M6.5,1402.3h276.9V-395.3H6.5V1402.3z",
"J":"M664.7,1402.3h276.9V-231.9L753.2-395.3l-556.1,0L6.5-231.9v710.4h276.9v-624.2l381.4,0V1402.3z",
"K":"M6.5,1402.3h276.9V744.1l385.9,658.2h286l-370-635.5L980.2-395.3H671.5L406,462.6L283.4,256.1v-651.4H6.5V1402.3z",
"L":"M6.5,1402.3h276.9v-1548l494.7,0v-249.7l-771.7,0V1402.3z",
"M":"M6.5,1402.3h463L608,664.6l145.3,737.7l463,0V-395.3l-274.6,0V814.4L687.4-395.3H535.3L283.3,794V-395.3H6.5V1402.3z",
"N":"M6.5,1402.3h286l329.1-876.1v876.1h276.9V-395.3H655.6L283.4,569.3v-964.6H6.5V1402.3z",
"O":"M939.6,1235.4V-232.2L749.3-395.3l-552.6,0L6.5-232.2v1467.6l190.2,163.1h552.6L939.6,1235.4zM282.8,1151.6V-146.1l380.5,0v1297.7H282.8z",
"P":"M6.5-395.3v1793.8h742.9l190.2-163.1V537.8l-188-163.1H282.7v-770.1H6.5zM663.3,1151.6H282.7V623.9l380.5,0V1151.6z",
"Q":"M939.5,1484.5V16.8L747.1-146.2h165.3v-249.1l-520.9,0v249.1l-197,0L6.5,16.8v1467.6l190.2,165.4h552.6L939.5,1484.5zM282.8,1400.7V102.9l380.5,0v1297.7H282.8z",
"R":"M6.5-395.3v1793.8h742.9l190.3-163.1V467.6L769.7,304.6l185.7-699.9h-342l-154,699.9l-176.7,0v-699.9H6.5zM663.3,1151.6H282.8V553.7h380.5V1151.6z",
"S":"M282.8,204.9v-351l328.4,0v620.5l-414.5,0L6.5,642v593.3l190.2,163.1h502.8l185.7-163.1V920.6H608.9v231H282.8v-428h414.5l188-165.3v-790.5l-188-163.1l-500.5,0L6.5-232.2v437.1L282.8,204.9z",
"T":"M285.1,1151.6H6.5v246.9h844.8v-246.9H561.3V-395.3H285.1V1151.6z",
"U":"M663.3,1398.5h274.1V-232.2l-188-163.1l-552.7,0L6.5-232.2v1630.7h276.3V-146.1l380.5,0V1398.5z",
"V":"M6.5,1398.5h296.7l154-1411l160.8,1411h287.6l-231-1793.8H242L6.5,1398.5z",
"W":"M629.3,1398.5H695l124.6-896.9l151.8,896.9h278.6L964.5-395.3l-212.9,0l-122.3,795L507-395.3H294.1L6.5,1398.5h280.9l149.4-896.9l126.8,896.9H629.3z",
"X":"M586.3,1398.5h294.5L633.9,544.6l292.1-940H611.2L466.3,186.8l-145-582.1H6.5l292.2,940L51.8,1398.5h294.5l120-516.4L586.3,1398.5z",
"Y":"M636.1-395.3H357.5v607L6.5,1398.5h301.2l190.3-733.8l194.8,733.8h296.7L636.1,211.7V-395.3z",
"Z":"M6.5-125.7l473.4,1277.3H22.3v246.9h774.6v-283.1L321.3-146.1l466.5,0v-249.2l-781.3,0V-125.7z",
"'":"M6.5,8l242,0v-262.8l-80.6-140.6H73.3l46.1,140.6l-112.9,0V8z",
"-":"M665.6-107.2v-288.1l-659.2,0v288.1L665.6-107.2z"
};// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 20,
    tracking = 2,
    panel_Hor_Adjustment = 2,
    font_Top_Adjustment = -4.5,
    middleSplitAdjustment = -.5,
    middleSpreadAdjustment = {
        left: 0.5,
        right: 0.5
    },
    Q_offset = {
        height: 2,
        vertical: .5
    },
    small_Caps_Adjustment = {
        vertical: -50,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    number_Adjustments = {
        top: 14,
        left: -7.5,
        width: 84,
        height: 62,
        spreadNumberCenterGap: 0,
        singleDigitOneOffset: 2,
        singleDigitSpread: 1.05
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF",
            ],
            away: [
                "#006F4A",
            ]
        },
        numbers: {
            home: [
                "#FFFFFF",
            ],
            away: [
                "#006F4A",
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: -4.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    };
